
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Student } from '@/types/models';
import AddStudentForm, { StudentFormValues } from './AddStudentForm';

interface AddStudentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onStudentAdded: (student: Omit<Student, 'id' | 'created_at'>, continueToDetails?: boolean) => void;
  familyId: string;
  isLoading: boolean;
  familyName?: string;
}

const AddStudentDialog: React.FC<AddStudentDialogProps> = ({
  open,
  onOpenChange,
  onStudentAdded,
  familyId,
  isLoading,
  familyName
}) => {
  const handleSubmit = (data: StudentFormValues, continueToDetails?: boolean) => {
    // Convert from form schema (firstName, lastName, dateOfBirth) 
    // to database model (first_name, last_name, date_of_birth)
    const student = {
      first_name: data.firstName,
      last_name: data.lastName,
      date_of_birth: data.dateOfBirth || null,
      gender: data.gender || null,
      notes: data.notes || '',
      family_id: familyId,
      organization_id: '' // This will be filled in by the handler
    };
    
    onStudentAdded(student, continueToDetails);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add New Student</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <AddStudentForm 
            familyId={familyId}
            onSubmit={handleSubmit}
            onCancel={() => onOpenChange(false)}
            isLoading={isLoading}
            familyName={familyName}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddStudentDialog;
